import { createContext, useContext, useState } from 'react'

export interface FiltersState {
  bookablePersonType: null | string
  includeDuplicates: null | boolean
  searchString: string | null
}

export const initialFilterState: FiltersState = {
  includeDuplicates: null,
  bookablePersonType: null,
  searchString: null,
}

interface FiltersContextType extends FiltersState {
  setFilters: (filters: Partial<FiltersState>) => void
  setSearchString: (val: string) => void
}

export const FiltersContextStore = createContext<FiltersContextType | undefined>(undefined)

const PeopleFiltersContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [filtersState, setFiltersState] = useState(initialFilterState)
  const setFilters = (filters: Partial<FiltersState>) => {
    setFiltersState((prevState) => {
      return {
        ...prevState,
        ...filters,
      }
    })
  }

  const setSearchString = (val: string) => {
    setFiltersState((prevState) => {
      return {
        ...prevState,
        searchString: val.length > 0 ? val : null,
      }
    })
  }

  return (
    <FiltersContextStore.Provider
      value={{
        ...filtersState,
        setSearchString,
        setFilters,
      }}
    >
      {children}
    </FiltersContextStore.Provider>
  )
}

export const usePeopleFiltersContext = () => {
  const context = useContext(FiltersContextStore)
  if (context === undefined) {
    throw new Error('useFiltersContext must be used within a FiltersContextProvider')
  }
  return context
}

export default PeopleFiltersContextProvider
